import React, { useEffect, useRef } from "react";

// Hyperspace-drop star streaks: while the carrier flies in, the CAMERA itself feels in
// motion - stars streak radially outward from the approach point and decelerate to a
// standstill as the ship parks, then the whole layer goes quiet. Pure canvas, one-shot.
export const ArrivalWarp = ({ duration = 6000, cx = 0.5, cy = 0.45 }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const dpr = window.devicePixelRatio || 1;
    const w = (canvas.width = canvas.offsetWidth * dpr);
    const h = (canvas.height = canvas.offsetHeight * dpr);
    const ox = w * cx, oy = h * cy;
    const maxD = Math.max(w, h);
    const stars = Array.from({ length: 260 }, () => ({
      a: Math.random() * Math.PI * 2,
      d: 40 + Math.random() * maxD * 0.6,
      v: 0.4 + Math.random() * 1.1,
    }));
    let raf, start;
    const tick = (ts) => {
      if (!start) start = ts;
      const t = Math.min((ts - start) / duration, 1);
      const speed = Math.pow(1 - t, 2.1); // decelerating out of warp alongside the ship
      ctx.clearRect(0, 0, w, h);
      if (speed <= 0.015) return; // parked - streaks are done for good
      stars.forEach((s) => {
        const step = speed * s.v * 30 * dpr;
        const len = Math.min(step * 2.6, 150 * dpr) * (0.3 + Math.min(s.d / (w * 0.4), 1));
        const cos = Math.cos(s.a), sin = Math.sin(s.a);
        const x1 = ox + cos * s.d, y1 = oy + sin * s.d;
        const x2 = ox + cos * (s.d + len), y2 = oy + sin * (s.d + len);
        ctx.strokeStyle = `rgba(190,235,255,${((0.06 + 0.55 * speed) * Math.min(s.d / 300, 1)).toFixed(3)})`;
        ctx.lineWidth = dpr;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        s.d += step;
        if (s.d > maxD) { s.d = 30 + Math.random() * 90; s.a = Math.random() * Math.PI * 2; }
      });
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [duration, cx, cy]);

  return (
    <canvas
      ref={canvasRef}
      className="absolute inset-0 w-full h-full pointer-events-none"
      style={{ zIndex: 1 }}
      data-testid="arrival-warp-canvas"
    />
  );
};
